'use client';

import { SectionHeading } from "@/components/taller/section-heading";
import { useTranslations } from "@/i18n/client";
import { Reveal } from "@/components/ui/reveal";

/** Modern Proceso section with a vertical timeline layout. */
export function Proceso() {
  const { t, isLoading } = useTranslations();
  const proceso = t('proceso');

  if (isLoading) return null;

  const steps = proceso.steps ?? [
    { title: 'Contacto', body: 'Nos cuentas tu idea en un formulario corto. Te respondemos en menos de 24 h.', time: 'Día 0' },
    { title: 'Propuesta', body: 'Te enviamos una maqueta inicial. La ajustamos contigo hasta que encaje.', time: 'Día 1–3' },
    { title: 'Construcción', body: 'Desarrollamos la web con SEO y automatizaciones a medida.', time: 'Día 3–7' },
    { title: 'Lanzamiento', body: 'Publicamos. Solo ahora hablamos de pago. Si no te encanta, no pagas.', time: 'Día 7' },
  ];

  return (
    <section className="py-24 md:py-32">
      <div className="max-w-[var(--container-max)] mx-auto px-6 md:px-14">
        <SectionHeading
          overline={proceso.overline || 'Cómo trabajamos'}
          heading={
            <>
              {proceso.heading || 'Cuatro pasos. '}
              <em>{proceso.headingAccent || 'Sin reuniones eternas.'}</em>
            </>
          }
          className="mb-20"
        />

        <div className="relative border-l border-[var(--color-border)] ml-4 md:ml-6">
          {steps.map((step, idx) => (
            <Reveal key={step.title} delay={idx * 0.1} width="100%">
              <div
                className="relative pl-10 md:pl-16 pb-12 last:pb-0 group"
              >
                {/* Timeline marker */}
                <div className="absolute -left-[13px] md:-left-[17px] top-0 w-6 h-6 md:w-8 md:h-8 rounded-full bg-[var(--color-bg)] border border-[var(--color-border)] flex items-center justify-center transition-colors duration-300 group-hover:border-[var(--color-accent)]">
                  <div className="w-2 h-2 rounded-full bg-[var(--color-accent)]" />
                </div>

                {/* Content Card */}
                <div className="p-6 md:p-8 rounded-[var(--radius-lg)] transition-all duration-200 hover:bg-[var(--color-surface)] group-hover:shadow-[var(--shadow-glow-card)]">
                  <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                    <div>
                      <div className="flex items-center gap-3 mb-2">
                      </div>
                      <h3 className="font-sans font-bold text-[22px] text-[var(--color-ink)] m-0 tracking-tight">
                        {step.title}
                      </h3>
                    </div>
                    <div className="font-mono text-[11px] tracking-widest uppercase text-[var(--color-mute)] md:text-right">
                      {step.time}
                    </div>
                  </div>
                  <p className="font-sans text-[15px] leading-[1.6] text-[var(--color-mute)] mt-4 mb-0 max-w-[600px]">
                    {step.body}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
